import { Button } from "antd"
import { useContext, useEffect, useRef, useState } from "react"
import Dialog from "@/libs/dialog"
import { LineRecord, NodeState, SetOperation, Spreadsheet } from "@/components/FlowSheetEditor/services/modal"
import styles from './styles.module.less'
import classNames from "classnames"
import { FlowsheetContext } from "@/components/FlowSheetEditor/FlowsheetProvider"
import { useRequest, useUpdateEffect } from "ahooks"
import { getSimUnitData } from "@/services/project/simulation.service"
import { getFlowSimulationSelector, getTopologyState } from "@/store/flowsheet/flowsheet.slice"
import { useSelector } from "react-redux"
import { NewSpreadsheet } from "@/components/Spreadsheet/NewSpreadsheet"
import { Subject, debounceTime } from "rxjs"
import { copyData } from "@/components/Spreadsheet/common"

interface SpreadsheetsProps {
  className?: string
  spreadsheet: Spreadsheet
  data?: any
  onSave?: (data, autoUpdate: boolean) => void
}

export const SpreadsheetDialog = (props: SpreadsheetsProps) => {
  const {className, spreadsheet, data = {name: 'test'}, onSave} = props;
  const [visible, setVisible] = useState(false)
  const {getAllUnits} = useContext(FlowsheetContext)
  const [units, setUnits] = useState<{nodes: NodeState[], lines: LineRecord[], operations: SetOperation[]}>({nodes: [], lines: [], operations: []})
  const spreadApiRef = useRef<{getData: () => any} | null>(null)
  const flowSimulation = useSelector(getFlowSimulationSelector)
  const {data: simData, run } = useRequest(() => getSimUnitData({sId: flowSimulation?.id, id: spreadsheet.id}))
  const topologyState = useSelector(getTopologyState)
  const onChangeRef = useRef<Subject<boolean>>(new Subject())

  useUpdateEffect(() => {
    if (topologyState && visible) {
      run()
    }
  }, [topologyState, visible])

  useEffect(() => {
    if (!visible) return
    getAllUnits().then((units) => {
      setUnits(units)
    })
  }, [visible])

  useEffect(() => {
    const sub = onChangeRef.current
    .pipe(debounceTime(1000))
    .subscribe((autoUpdate = false) => {
      const {getData} = spreadApiRef.current || {}
      if (!getData) {
        return;
      }
      const sheetVal = getData()
      onSave?.(sheetVal, autoUpdate)
    })
    return () => {
      sub.unsubscribe()
    }
  }, [onSave])

  return <div className={classNames([styles.container, className])}>
    <Button type="link" size="small" onClick={() => setVisible(true)}>Open</Button>
    {visible && <Dialog className="full-screen" onClose={() => setVisible(false)} width={1000} title={`Spreadsheet - ${spreadsheet.tag}`} visible={true} footer={null}>
      <NewSpreadsheet
        units={units}
        ref={spreadApiRef}
        data={copyData(data)}
        onChange={(autoUpdate = false) => onChangeRef.current.next(autoUpdate)}
        simData={simData} />
    </Dialog>}
  </div>
}